import React, { useMemo } from "react";
import { TableProps } from "../../types/table";

const TableComponent = <T,>({ columns, data }: TableProps<T>): JSX.Element => {
  const tableHeaders = useMemo(
    () =>
      columns.map((col, index) => {
        const isLastColumn = index === columns.length - 1;
        return (
          <th
            key={col.header}
            className={`px-4 py-2 whitespace-nowrap font-medium text-gray-700 ${
              isLastColumn
                ? "sticky right-0 bg-gray-100 z-20"
                : ""
            }`}
          >
            {col.header}
          </th>
        );
      }),
    [columns]
  );

  const tableRows = useMemo(
    () =>
      data.map((row, i) => (
        <tr key={i} className="border-t hover:bg-gray-50">
          {columns.map((col, j) => {
            const isLastColumn = j === columns.length - 1;
            const value = row[col.accessor];
            return (
              <td
                key={j}
                className={`px-4 py-2 text-gray-800 ${
                  isLastColumn
                    ? "sticky right-0 bg-white hover:bg-gray-50 z-10"
                    : ""
                }`}
              >
                <div className="linkCol">
                  {col.render
                    ? col.render(value, row)
                    : (value as React.ReactNode)}
                </div>
              </td>
            );
          })}
        </tr>
      )),
    [data, columns]
  );

  return (
    <div className="overflow-x-auto overflow-y-auto rounded-lg shadow" style={{ maxHeight: "70vh" }}>
      <table className="min-w-full border border-gray-200 text-sm text-left" style={{ borderCollapse: "collapse" }}>
        <thead className="bg-gray-100 sticky top-0 z-30">
          <tr>{tableHeaders}</tr>
        </thead>
        <tbody>{tableRows}</tbody>
      </table>
    </div>
  );
};

export const Table = React.memo(TableComponent) as typeof TableComponent;
